// .category-submenu-text要素を全て取得する
const accordionItems = document.querySelectorAll('.accordion-title');
const categorysubsubmenu = document.querySelectorAll('.category-sub-submenu');
// 各アイテムにクリックイベントを追加する
accordionItems.forEach((item, index) => {
  item.addEventListener('click', () => {
    if (item.classList.contains('active')) {
      categorysubsubmenu[index].style.height = 0;
      item.classList.toggle('active');
      categorysubsubmenu[index].classList.toggle('active');
    } else {
      categorysubsubmenu[index].style.height = 'auto'; //いったんautoに
      categorysubsubmenu[index].classList.toggle('active');
      let itemHeight = categorysubsubmenu[index].offsetHeight; //autoにした要素から高さを取得
      categorysubsubmenu[index].style.height = itemHeight + 'px';
      categorysubsubmenu[index].animate(
        [
          //高さ0から取得した高さまでのアニメーション
          { height: 0 },
          { height: itemHeight + 'px' },
        ],
        {
          duration: 300, //アニメーションの時間（ms）
        }
      );
      item.classList.toggle('active');
    }
  });
});
